
import { defineComponent } from 'vue'
import { createValidations, ICustomValidatorMap } from '@/helpers/commons/validationHelper'
import Dropdown from 'primevue/dropdown'
import useValidate from '@vuelidate/core'
import useModeDescriptor from './UseModesDescriptor.json'
import useModeValidationtDescriptor from './UseModeValidationDescriptor.json'
import KnValidationMessages from '@/components/UI/KnValidatonMessages.vue'
import LovsDialog from './DriversManagementLovsDialog.vue'
export default defineComponent({
    name: 'detail-card',
    components: { Dropdown, KnValidationMessages, LovsDialog },
    props: {
        selectedMode: {
            type: Object,
            required: false
        },
        selectionTypes: {
            type: Array,
            required: true
        },
        layers: {
            type: Array,
            required: true
        },
        lovs: {
            type: Array,
            required: true
        },
        isDate: {
            type: Boolean,
            required: true
        },
        showMapDriver: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            mode: {} as any,
            useModeDescriptor,
            selectedType: null,
            selectedDefault: null as any,
            selectedMax: null as any,
            lov: null as any,
            lovType: null as any,
            dialogVisiable: false,
            v$: useValidate() as any,
            useModeValidationtDescriptor
        }
    },
    validations() {
        const customValidators: ICustomValidatorMap = {
            required_type_for_lov: () => {
                return this.mode.valueSelection != 'lov' || this.mode.selectionType != null
            },
            required_lovId_for_lov: () => {
                return this.mode.valueSelection != 'lov' || this.mode.typeLov.name != null
            },
            required_for_pick_up: () => {
                return this.selectedDefault != 'pickUp' || (this.mode.defaultFormula != '' && this.mode.defaultFormula != null)
            },
            required_lov_for_default: () => {
                return this.selectedDefault != 'lov' || this.mode.defLov.name != null
            },
            required_lov_for_max: () => {
                return this.selectedMax != 'lov' || this.mode.maxLov.name != null
            }
        }
        const validationObject = {
            mode: createValidations('mode', useModeValidationtDescriptor.validations.mode, customValidators)
        }
        return validationObject
    },
    computed: {
        defaults(): any {
            return this.useModeDescriptor.defaultValues
        },
        availableTypes(): any {
            return this.useModeDescriptor.types
        }
    },
    watch: {
        selectedMode() {
            this.v$.$reset()
            this.mode = this.selectedMode as any
            this.handleDropdowns()
            this.v$.$touch()
            setTimeout(() => {
                this.modeChanged()
            }, 500)

            this.handleLovs()
        }
    },
    mounted() {
        if (this.selectedMode) {
            this.mode = this.selectedMode as any
            this.handleDropdowns()
        }
        this.v$.$touch()
        this.handleLovs()
        setTimeout(() => {
            this.modeChanged()
        }, 500)
    },
    methods: {
        showLovsDialog(lovType: string) {
            this.dialogVisiable = true
            switch (lovType) {
                case 'type':
                    this.lov = this.mode.typeLov
                    this.lovType = 'type'
                    break
                case 'default':
                    this.lov = this.mode.defLov
                    this.lovType = 'default'
                    break
                case 'max':
                    this.lov = this.mode.maxLov
                    this.lovType = 'max'
                    break
            }
        },
        handleDropdowns() {
            if (this.mode.defaultFormula == null) {
                this.selectedDefault = 'none'
            } else {
                this.selectedDefault = 'pickUp'
            }
            if (this.mode.idLovForDefault != null) {
                this.selectedDefault = 'lov'
            }

            if (this.mode.idLovForMax != null) {
                this.selectedMax = 'lov'
            } else {
                this.selectedMax = 'none'
            }
        },
        setType() {
            this.selectedDefault = 'none'
            switch (this.mode.valueSelection) {
                case 'lov':
                    this.mode.manualInput = 0
                    this.mode.selectedLayer = null
                    this.mode.selectedLayerProp = null
                    break
                case 'man_in':
                    this.mode.idLov = null
                    this.mode.typeLov = { name: null }
                    this.mode.selectionType = null
                    this.mode.selectedLayer = null
                    this.mode.selectedLayerProp = null
                    break
            }
            this.modeChanged()
        },
        setDefault() {
            switch (this.selectedDefault) {
                case 'none':
                    this.mode.defaultFormula = null
                    this.mode.idLovForDefault = null
                    this.mode.defLov = { name: null }
                    break
                case 'lov':
                    this.mode.defaultFormula = null
                    break
                case 'pickUp':
                    this.mode.idLovForDefault = null
                    this.mode.defLov = { name: null }
                    break
            }
            this.modeChanged()
        },
        setMax() {
            if (this.selectedMax == 'none') {
                this.mode.idLovForMax = null
                this.mode.maxLov = { name: null }
            }
            this.modeChanged()
        },
        setDirty() {
            this.$emit('touched')
        },
        modeChanged() {
            this.mode.numberOfErrors = this.v$.$errors.length
            this.mode.edited = true
        },
        applyLov(lov: any) {
            this.dialogVisiable = false
            switch (this.lovType) {
                case 'type':
                    this.mode.typeLov = lov
                    this.mode.idLov = lov.id
                    break
                case 'default':
                    this.mode.defLov = lov
                    this.mode.idLovForDefault = lov.id
                    break
                case 'max':
                    this.mode.maxLov = lov
                    this.mode.idLovForMax = lov.id
                    break
            }
            this.modeChanged()
        },
        handleLovs() {
            if (this.mode.idLov) {
                this.mode.typeLov = this.lovs?.filter((lov: any) => lov.id == this.mode.idLov)[0]
            } else this.mode.typeLov = { name: null }
            if (this.mode.idLovForDefault) {
                this.mode.defLov = this.lovs?.filter((lov: any) => lov.id == this.mode.idLovForDefault)[0]
            } else this.mode.defLov = { name: null }
            if (this.mode.idLovForMax) {
                this.mode.maxLov = this.lovs?.filter((lov: any) => lov.id == this.mode.idLovForMax)[0]
            } else this.mode.maxLov = { name: null }
        }
    }
})
